<template>
  <div class="tw-container tw-m-auto tw-mt-32 md:tw-w-2/3 tw-p-4 tw-w-full">
    <div class="tw-relative tw-z-10 tw-font-sans md:tw-text-right tw-text-center md:tw-text-3xl tw-text-3xl tw-mr-4">
      <h1>{{selectedLanguage == 'US' ? en.title_3_1 : pt.title_3_1}}</h1>
    </div>
    <hr class="tw-relative tw-z-10 tw-border-dashed tw-border-sky-700 tw-mt-1">
    <section id="albums" class="tw-items-center tw-py-8 tw-mt-8" v-if="Object.keys(albums).length">
      <div class="tw-container tw-mx-auto tw-relative">
        <div class="tw-flex tw-items-center tw-justify-center tw-flex-wrap">
          <div class="tw-flex tw-justify-between tw-w-full tw-items-center tw-px-4 md:tw-px-0">
              <h6 class="tw-text-white tw-font-sans">{{selectedLanguage == 'US' ? en.last_album : pt.last_album}}</h6>
              <div class="tw-space-x-2 tw-text-xl tw-hidden lg:tw-flex">
                  <i class="fas fa-chevron-circle-left tw-text-white swiper-button-prev tw-cursor-pointer tw-outline-none"></i>
                  <i class="fas fa-chevron-circle-right tw-text-white swiper-button-next tw-cursor-pointer tw-outline-none"></i>
              </div>
          </div>
          <div class="swiper-container tw-w-full tw-mt-5">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="album in albums" :key="album.id">
                  <v-img :src="album.images[0].url" class="tw-shadow-lg tw-rounded-md tw-border tw-border-gray-900" aspect-ratio="1">
                    <inertia-link :href="tenant ? `/album/${album.id}` : `/album/${artist.artista_url}/${album.id}`" class="tw-w-full tw-h-full tw-absolute tw-flex-wrap tw-items-center tw-justify-center tw-text-center tw-flex single-slider" style="background:rgba(0,0,0,0.6)">
                      <div class="tw-block tw-px-5 tw-truncate tw-w-full" style="margin-bottom: 132px">
                        <h6 class="tw-uppercase tw-font-sans tw-text-white tw-font-bold tw-p-0 tw-truncate tw-m-0">{{album.name}}</h6>
                        <div class="tw-font-sans tw-text-white tw-font-semibold tw-w-full tw-text-xs tw-truncate">
                            <span v-for="(artist, index) in album.artists" :key="artist.id">
                                <span>{{artist.name}}</span>
                                <span v-if="index !== album.artists.length - 1" class="tw--ml-1 tw-mr-1">,</span>
                            </span>
                        </div>
                      </div>
                      <div class="tw-w-full tw-h-full tw-absolute tw-top-0 tw-left-0 tw-flex-wrap tw-items-center tw-justify-center tw-text-center tw-flex single-slider">
                        <v-btn class="ma-2" outlined large fab color="white">
                            <v-icon>fas fa-play</v-icon>
                        </v-btn>
                      </div>
                    </inertia-link>
                  </v-img>
                </div>
              </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
import Layout from '@/Shared/Layout2';
import EventBus from '@/eventbus';
import Swiper from 'swiper';
import pt from "../../../../../lang/smartsite/layout_2/layout_2.js";
import Single from '@/components/single';

export default {
  mixins: [pt],
  layout: (h, page) => h(Layout, [page]),
  layout: Layout,
  props: ['artist', 'pageOptions', 'spotifyArtist', 'singles', 'albums'],
  components: {Single},
  computed: {
    selectedLanguage() {
      return this.$page.props.lang;
      }
  },
  created(){
    EventBus.$emit('artist', {'artist': this.artist, 'pageOptions': this.pageOptions});
  },
  mounted() {
    var albunsSwiper = new Swiper('#albums .swiper-container', {
            slidesPerView: 1.25,
            slidesPerGroup: 1,
            spaceBetween: 20,
            slidesOffsetBefore: 15,
            slidesOffsetAfter: 15,
            observer: true,
            observeParents: true,
            observeSlideChildren:true,
            navigation: {
                nextEl: '#albums .swiper-button-next',
                prevEl: '#albums .swiper-button-prev',
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                },
                1024: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                },
                1280: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                },
            },
        });
  }
}
</script>

<style scoped>

.wrapper {
  position: relative;
  width: 100%;
  margin: 0 auto;
}

.wrapper:hover img {
  opacity: .5;
}

.wrapper:hover .overlay {
  opacity: 1;
  transition: 0.4s;
}

img {
  opacity: 1;
  display: block;
  width: 100%;
  height: auto;
  transition: 1s ease;
}

.overlay {
  opacity: 0;
}

.content {
  width: 91%;
  height: 91%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  overflow: hidden;
  background-color: rgba(0, 0, 0, 70%);
}

.align-icons {
  width: 100%;
  padding: 0 20%;
  text-align: center;
}

h1 {
  color: #d6d6d6;
}

.bg-cover {
  position: absolute;
  top: 0;
  width: 100%;
  left: 0;
  bottom: 0;
  right: 0;
  background-position: 30% 45%;
  background-size: cover;
  z-index: 0;
}
    
</style>